





import { Component, Vue } from 'vue-property-decorator'

import firebase from 'firebase/app'
import 'firebase/auth'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

@Component
export default class App extends Vue {
  /**
   * Before-create vue lifecycle-hook
   */
  beforeCreate(): void {
    // Add listeners for browser online and offline state events
    window.addEventListener('online', () => {
      this.$store.commit('setConnectionState', true)
    })
    window.addEventListener('offline', () => {
      this.$store.commit('setConnectionState', false)
      // this.onLine = false
    })

    firebase.auth().onAuthStateChanged((user) => {
      // initially user = null, after auth it will be either <fb_user> or false
      this.$store.commit('setUser', user || false)

      if (user && this.$route.path === '/login') {
        this.$router.replace('/')
      } else if (!user && this.$route.path !== '/login') {
        this.$router.replace('/login')
      }
    })
  }
}
